import {
  useCustomerWishlistSkus 
} from "@/common/hooks/useCustomerWishlistSkus/useCustomerWishlistSkus"
import mergeOperations from "@/util/shallowMerge"
import defaultOperations from "./gallery.gql"

export const useGallery = (props = {}) => {
  const operations = mergeOperations(defaultOperations, props.operations)

  useCustomerWishlistSkus()

  // const { data: storeConfigData } = useQuery(operations.getStoreConfigQuery, {
  //     fetchPolicy: 'cache-and-network',
  // })

  const storeConfigData = {
    "storeConfig": {
      "__typename": "StoreConfig",
      "store_code": process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
      "product_url_suffix": ".html",
      "magento_wishlist_general_is_enabled": "1"
    }
  }

  const storeConfig = storeConfigData ? storeConfigData.storeConfig : null

  return {
    storeConfig,
  }
}
